import { useCreateStripeCustomerPortalSessionMutation } from '@generated/graphql';
import { useNotifications } from '@notifications/Notifications';
import { useCallback } from 'react';

export const useStripeCustomerPortal = ({ organizationId }: { organizationId: string }) => {
  const { addNotification } = useNotifications();
  const [createStripeCustomerPortalSession] = useCreateStripeCustomerPortalSessionMutation();

  const openStripeCustomerPortal = useCallback(() => {
    if (typeof window === 'undefined') return;
    void createStripeCustomerPortalSession({
      variables: {
        organizationId,
        returnUrl: window.location.href,
      },
      onError: (error) => {
        addNotification({
          type: 'error',
          text: error.message,
        });
      },
      onCompleted: (data) => {
        if (data?.createStripeCustomerPortalSession?.url) {
          window.open(data?.createStripeCustomerPortalSession?.url, '_blank');
        } else {
          addNotification({
            type: 'error',
            text: 'Failed to open customer portal',
          });
        }
      },
    });
  }, [createStripeCustomerPortalSession, addNotification, organizationId]);

  return { openStripeCustomerPortal };
};
